import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const config = {
    id: ActionType.CHANGE_TEMPLATE_CONTENT,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        shrinkable: 'steps',
        style: {
        },

        shrinkSteps: [312, 384],
        widthRange: [240, 456],
        preventHighlight: true,
        respectOffline: true,
    },
];
